export default "__VITE_ASSET__9DOZn7Ih__"